import { Navigate, Outlet, useLocation } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Header from "../../components/header/Header";
import { useAppSelector } from "../../app/hooks";
import { selectIsNavbar } from "../../selectors/layoutSelectors";
import "./privateLayout.scss";
import IdleTimer from "components/utils/IdleTimer";
import useGetUserInfo from "queryHooks/authQueryHooks/useGetUserInfo";
import { selectIsLoading } from "selectors/loaderSelectors";
import { LoadingOverlay } from "@trcsolutions/springboard-ui";
import ChatBot from "components/ChatBot/ChatBot";

const MainContent = () => {
  const isNavbar = useAppSelector(selectIsNavbar);
  return (
    <div className="main" style={{ marginLeft: isNavbar ? "160px" : "100px" }}>
      <Outlet />
    </div>
  );
}

export function Component() {
  useGetUserInfo();
  const location = useLocation();
  const isLoader = useAppSelector(selectIsLoading);

  if (!(localStorage.getItem("token") && localStorage.getItem("user"))) {
    return <Navigate to="/auth/login" replace state={{ from: location }} />;
  }

  return (
    <div className="wrapper">
      <Header />
      <Sidebar />
      <MainContent />
      <ChatBot />
      <IdleTimer />
      <LoadingOverlay show={isLoader} />
    </div>
  );
}
